import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import ImageCard, { ImageCardProps } from 'src/app/molecules/ImageCard/ImageCard';
import { ImageCardWrapper } from './ImageCardList.styles';

interface ImageCardListProps {
  imageCards: ImageCardProps[];
  totalColumns?: number;
  totalColumnsLg?: number;
  totalColumnsSm?: number;
}

const ImageCardList = ({
  imageCards,
  totalColumns = 3,
  totalColumnsLg = 2,
  totalColumnsSm = 1,
}: ImageCardListProps): JSX.Element => {
  return (
    <Grid
      gap={['spacing-6xl', 'spacing-3xl']}
      gapLg='spacing-3xl'
      totalColumns={totalColumns}
      totalColumnsLg={totalColumnsLg}
      totalColumnsSm={totalColumnsSm}
    >
      {imageCards.map((imageCard, index) => (
        <ImageCardWrapper
          key={index}
          columns={1}
        >
          <ImageCard
            className='image-card-item'
            {...imageCard}
          />
        </ImageCardWrapper>
      ))}
    </Grid>
  );
};

export default ImageCardList;
